import {
  LayoutBuilderViewStore,
  YardOperationsViewStore,
  SurfaceViewStore,
} from "@intrasync/yard-management";

/**
 * Yard Management view stores from `@intrasync/yard-management`.
 *
 * Each class is instantiated as `new Store(rootStore)` by RootStore (see
 * src/stores/RootStore.ts) and mounted under the `name` key below.
 */
const yardManagementStoreList = [
  { name: "layoutBuilderViewStore", store: LayoutBuilderViewStore },
  { name: "yardOperationsViewStore", store: YardOperationsViewStore },
  { name: "surfaceViewStore", store: SurfaceViewStore },
];

export default yardManagementStoreList;
